import React from 'react';

/**
 * Shimmer skeleton placeholder. Use for content that loads on page entry
 * (cards, tables, charts) — not for user-triggered actions (keep a spinner
 * / disabled button for Save / Delete / Export).
 */
const Skeleton = ({ width = '100%', height = 14, radius = 7, className = '', style = {} }) => (
    <span
        className={`sb-skel ${className}`}
        aria-hidden="true"
        style={{ width, height, borderRadius: radius, ...style }}
    />
);

/** Convenience: a stack of skeleton "rows" approximating a loading table/list. */
export const SkeletonRows = ({ rows = 4, widths = ['30%', '45%', '18%'] }) => (
    <div className="sb-skel-list">
        {Array.from({ length: rows }).map((_, r) => (
            <div className="sb-skel-row" key={r}>
                {widths.map((w, c) => <Skeleton key={c} width={w} height={13} />)}
            </div>
        ))}
    </div>
);

/** Convenience: a bar silhouette that reads as a loading chart (bar or line). */
export const SkeletonChart = ({ bars = [52, 38, 68, 34, 60, 44, 80] }) => (
    <div className="sb-skel-chart">
        {bars.map((h, i) => <Skeleton key={i} width="100%" height={`${h}%`} radius={6} />)}
    </div>
);

export default Skeleton;
